import { useEffect, useState } from 'react'
import { auth } from '../../firebase'
import { onAuthStateChanged, getIdTokenResult } from 'firebase/auth'
import { Box, Button, Card, CardContent, Stack, Typography, Alert } from '@mui/material'
import { db } from '../../firebase'
import { doc, setDoc, getDoc } from 'firebase/firestore'
import { useNavigate } from 'react-router-dom'

export default function BootstrapPage() {
  const [loading, setLoading] = useState(true)
  const [email, setEmail] = useState<string>('')
  const [uid, setUid] = useState<string>('')
  const [message, setMessage] = useState<string>('')
  const [error, setError] = useState<string>('')
  const [alreadyAdmin, setAlreadyAdmin] = useState<boolean>(false)
  const nav = useNavigate()

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (user) => {
      if (!user) {
        setLoading(false)
        return
      }
      setEmail(user.email || '')
      setUid(user.uid)
      const token = await getIdTokenResult(user)
      const role = token.claims['role'] as string | undefined
      if (role === 'admin' || role === 'super_admin') {
        setAlreadyAdmin(true)
      }
      setLoading(false)
    })
    return () => unsub()
  }, [])

  const assignSuperAdmin = async () => {
    setError('')
    setMessage('')
    try {
      setLoading(true)
      // البريد المصرح به للتمهيد: من متغير البيئة أو القيمة الافتراضية
      const bootstrapEmail = (import.meta.env.VITE_BOOTSTRAP_EMAIL as string) || 'wellaeg@hotmail.com'
      if ((email || '').toLowerCase() !== bootstrapEmail.toLowerCase()) {
        setError('هذا البريد غير مصرح له بالتمهيد')
        return
      }
      // إذا كان هناك سجل مسبقاً، اعتبره ناجحاً
      const ref = doc(db, 'admin_emails', email)
      const exists = await getDoc(ref)
      if (!exists.exists()) {
        await setDoc(ref, { createdAt: new Date().toISOString(), by: 'bootstrap' })
      }
      setMessage('تم تفعيل صلاحيات الأدمن بنجاح. سيتم إعادة التوجيه خلال لحظات.')
      setTimeout(() => nav('/'), 1200)
    } catch (e: any) {
      setError(e.message || 'خطأ غير متوقع')
    } finally {
      setLoading(false)
    }
  }

  if (loading) return null

  if (!auth.currentUser) {
    return (
      <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Card sx={{ width: 420 }}>
          <CardContent>
            <Stack spacing={2}>
              <Typography align="center">الرجاء تسجيل الدخول أولاً</Typography>
              <Button variant="contained" onClick={() => nav('/login')}>الذهاب لتسجيل الدخول</Button>
            </Stack>
          </CardContent>
        </Card>
      </Box>
    )
  }

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Card sx={{ width: 480 }}>
        <CardContent>
          <Stack spacing={2}>
            <Typography variant="h6" align="center">Bootstrap Super Admin</Typography>
            <Typography align="center">المستخدم الحالي: {email || '—'}</Typography>
            {alreadyAdmin && <Alert severity="info">لديك صلاحيات إدارية بالفعل. يمكنك الذهاب للوحة التحكم.</Alert>}
            {message && <Alert severity="success">{message}</Alert>}
            {error && <Alert severity="error">{error}</Alert>}
            <Button variant="contained" disabled={loading || alreadyAdmin} onClick={assignSuperAdmin}>
              تعيين حسابي كـ Super Admin
            </Button>
            <Button onClick={() => nav('/')}>العودة للوحة التحكم</Button>
          </Stack>
        </CardContent>
      </Card>
    </Box>
  )
}
